<template>
  <div v-if="test">
    <div class="page-title mb-3">
      진단평가 : {{test.name}} / {{test.code}}
    </div>
    <div v-for="(u, ux) in test.units" :key="u._id">
      <div class="bolder">
        <mdb-badge color="primary" class="p-1">평가 영역</mdb-badge> {{u.name}} / {{u.code}}
      </div>
      <mdb-tbl sm>
        <mdb-tbl-head>
          <th>수행 준거</th>
          <th class="text-center" style="width:60px">예</th>
          <th class="text-center" style="width:60px">아니오</th>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="(c,ix) in u.content " :key="ix">
            <td style="font-size: 15px">{{c}}</td>
            <td class="text-center" >
              <input type="radio" v-model="answer.units[ux].answer[ix]" :value="true">
            </td>
            <td class="text-center" >
              <input type="radio" v-model="answer.units[ux].answer[ix]" :value="false">
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
    <div class="text-center"><mdb-btn icon="share-square" color="primary" @click="onSave()">제출하기</mdb-btn></div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'StudentPerformSelfTestExam',
  components: {},
  props: [],
  data: () => ({
    TAG: 'StudentPerformSelfTestExam :',
    answer: {},
    code: '',
    test: undefined
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training', 'subjects']),
    ...mapGetters('training', ['teacher'])
  },
  methods: {
    getTest (code) {
      for (let i = 0; i < this.subjects.NCS.length; i++) {
        if (!this.subjects.NCS[i]) continue
        const l = this.subjects.NCS[i].lectures.find(l => l.code === code)
        if (l) return l
      }
    },
    load () {
      if (!this.subjects.NCS) return
      const { code } = this.$route.query
      this.test = this.getTest(code)
      if (this.test) {
        this.answer = this.$PerformSelfTestAnswer.create(this.training._id, this.profile._id, this.teacher, this.test)
      } else {
        console.log('능력단위 없음')
      }
    },
    async onSave () {
      if (!confirm('제출할까요?')) return
      await this.answer.save()
      this.$router.back()
    }
  },
  created () {
    this.load()
  },
  watch: {
    subjects () { this.load() }
  }
}
</script>
